var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLineTool = function SvgLineTool(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "none",
    stroke: "#000"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "inherit",
    strokeWidth: 1.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "m6.906 20.195 6.814-1.606M17.86 14.578l1.58-6.82"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.599,
    cy: 20.903,
    r: 2.974
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.067,
    cy: 17.755,
    r: 2.974
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.403,
    cy: 4.575,
    r: 2.974
  }))));
};
export default SvgLineTool;